export default __webpack_public_path__ + "static/media/Red.5630bda9.png";